import React from "react";
import { AuthProvider } from "./auth";
import { ToastProvider } from "./toast";
import { CompaniesProvider } from "./companies";
import { ThemeProvider } from "./theme";
import { LegendProvider } from "./legend";
import { DateFilterProvider } from "./datefilter";
import { FeaturesProvider } from "./features";
import { ActiveProductProvider } from "./activeProduct";

// FeaturesProvider depende de CompaniesProvider (refetch ao trocar empresa).
// ActiveProductProvider depende de FeaturesProvider (escolhe default a partir
// das features contratadas).
const AppProvider = ({ children }) => (
  <AuthProvider>
    <ThemeProvider>
      <LegendProvider>
        <DateFilterProvider>
          <CompaniesProvider>
            <FeaturesProvider>
              <ActiveProductProvider>
                <ToastProvider>{children}</ToastProvider>
              </ActiveProductProvider>
            </FeaturesProvider>
          </CompaniesProvider>
        </DateFilterProvider>
      </LegendProvider>
    </ThemeProvider>
  </AuthProvider>
);

export default AppProvider;